module.exports = __webpack_public_path__ + "static/media/asma.9f307df3.jpg";